/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */
import * as Msdyn365 from '@msdyn365-commerce/core';
import {IAny, ICreateActionContext, IGeneric } from '@msdyn365-commerce/core';
import { SimpleProduct } from '@msdyn365-commerce/retail-proxy';

// import { createObservableDataAction } from '@msdyn365-commerce/action-internal';
import { IAction, IActionContext } from '@msdyn365-commerce/core-internal';
import { searchByCriteriaAsync } from '@msdyn365-commerce/retail-proxy/dist/DataActions/ProductsDataActions.g';
import { ProductSearchCriteria, ProductSearchResult } from '@msdyn365-commerce/retail-proxy/dist/Entities/CommerceTypes.g';
// @ts-ignore
import { CATEGORY_PAGE_NAME } from '@msdyn365-commerce/runtime-internal/dist/lib/consts';
// @ts-ignore
import { getProductImageUrls } from '@msdyn365-commerce/runtime-internal/dist/lib/utils/product-list-utils';
import { getSelectedProductIdFromActionInput } from '@msdyn365-commerce-modules/retail-actions';

/**
 * PostContactEvent Input Action
 */
 export class ProductsBySimilarLooksInput implements Msdyn365.IActionInput {
    public productId: number;
    public channelId: number;
    public catalogId: number;
    public selectedProduct: SimpleProduct | undefined;
    // Construct the input needed to run the action
    constructor(productId: number, channelId: number, catalogId?: number) {
        this.productId = productId;
        this.channelId = channelId;
        this.catalogId = catalogId || 0;
    }

    public getCacheKey = () => `ProductsBySimilarLooksCacheKey`;
    public getCacheObjectType = () => 'ProductsBySimilarLooksEventObjectType';
    public dataCacheType = (): Msdyn365.CacheType => 'request';
}


export const createProductsBySimilarLooksInput = (inputData: ICreateActionContext<IGeneric<IAny>>): ProductsBySimilarLooksInput => {
    const productId = getSelectedProductIdFromActionInput(inputData);

    if (productId) {
        return new ProductsBySimilarLooksInput(+productId, +inputData.requestContext.apiSettings.channelId);
    } else {
        throw new Error('Unable to create PriceForSelectedVariantInput, no productId found on module config or query');
    }
};


export const getProductsBySimilarLooks = async (input: ProductsBySimilarLooksInput, context: IActionContext): Promise<ProductSearchResult[]> => {
    let productId: number;
    if (input.productId) {
        productId = input.productId;
    } else {
        // Unable to determine category from list meta data or context
        throw new Error('productId Missing for ProductsByCategory List');
    }
    context.telemetry.debug(`Category Id input to ProductsByCategory action : ${productId}`);
    const productSearchCriteria: ProductSearchCriteria = {
        Context: {
            ChannelId: +input.channelId,
            CatalogId: +input.catalogId,
        },
        Refinement: [],
        IncludeAttributes: false,
        SkipVariantExpansion: true, 
        RecommendationListId: "looks", 
        Ids: [productId]
    };

    return searchByCriteriaAsync(
        { callerContext: context, queryResultSettings: { Paging: { Top: 10 } } },
        productSearchCriteria
    )
        .then((products: ProductSearchResult[]) => {
            context.telemetry.debug('Products returned by ProductByCategory action', products);
            return getProductImageUrls(products, context.requestContext.apiSettings);
        })
        .catch(error => {
            context.telemetry.error(`Error running ProductByCategory action: ${error}`);
            throw new Error(error);
        });
};

export default Msdyn365.createObservableDataAction({
    action: <IAction<ProductSearchResult[]>>getProductsBySimilarLooks,//<Msdyn365.IAction<IGetJournalPostsData>>action,
    input: createProductsBySimilarLooksInput
});